import React, { useContext } from 'react';
var ContentComponentContext = /*#__PURE__*/React.createContext(undefined);
export var ContentComponentContextProvider = ContentComponentContext.Provider;

/**
 * @example
 * ```tsx
 * const {editorView, api} = useContentComponentContext();
 * ```
 */
export var useContentComponentContext = function useContentComponentContext() {
  var context = useContext(ContentComponentContext);
  if (!context) {
    throw new Error('No Editor view or API available in the context, make sure to have container wrapped with ContentComponentContextProvider');
  }
  return context;
};